import { IQuoteRespSchema } from '@monetize/types/app';
import { Maybe } from '@monetize/types/common';
import { useGetQuoteBillingSchedule } from '../api/cpqService';

export const useBillingSchedule = (quote?: Maybe<IQuoteRespSchema>) => {
  /**
   * This will re-fetch the billing schedule whenever the quote is modified
   */
  const { data: quoteBillingSchedule, isFetching: loading } =
    useGetQuoteBillingSchedule(
      quote?.id || '',
      'V2',
      // additional query key to auto-fetch on quote modification
      [quote?.modifyDate],
      {
        enabled: !!quote?.id,
        // Never consider the data stale if we have it already
        staleTime: Infinity,
        // 5 minutes
        gcTime: 300000,
        placeholderData: (previousData, previousQuery) => previousData,
        meta: { showErrorToast: true },
      },
    );

  return {
    loading,
    quoteBillingSchedule,
  };
};
